<div class="select-hubspot-company-page-container container" fxLayout="column" fxLayoutGap="15px" [formGroup]="form">
  <h3 class="mat-h3 color-primary text-small-caps">{{ 'HUBSPOT.EXISTING_RECORDS_FOUND' | translate }}</h3>
  <p>{{ 'HUBSPOT.DESCRIPTION' | translate }}</p>

  <mat-radio-group color="primary" formControlName="hubspotId" fxLayout="column" fxLayoutGap="5px">
    <mat-radio-button [value]="null">
      <div fxLayout="column">
        <strong>{{ 'HUBSPOT.NONE' | translate }}</strong>
        <span class="color-muted">({{ 'HUBSPOT.CREATE_NEW' | translate }})</span>
      </div>
    </mat-radio-button>

    <mat-radio-button *ngFor="let option of options" [value]="option.id">
      <div fxLayout="column">
        <strong>{{ option.properties.name }}</strong>
        <span class="color-muted">{{ option.getContactsAsString() }}</span>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</div>
